import { z } from 'zod';

import type { TargetingLanguage } from '../../targeting/model';

export function madBuyLanguageKey(language: TargetingLanguage) {
  return language.isoCode3 ?? language.isoCode2 ?? language.code ?? language.id;
}

export function selectMadBuyLanguages(
  catalog: readonly TargetingLanguage[],
  selected: readonly TargetingLanguage[],
  keys: readonly string[],
) {
  const byKey = new Map(selected.map((language) => [madBuyLanguageKey(language), language]));
  const selectedKeys = new Set(keys);
  return catalog
    .filter((language) => selectedKeys.has(madBuyLanguageKey(language)))
    .map((language) => ({ ...language, ...byKey.get(madBuyLanguageKey(language)) }));
}

export function serializeMadBuyLanguage(language: TargetingLanguage) {
  const id = z.uuid().safeParse(language.id);
  return {
    ...(id.success ? { id: id.data } : {}),
    name: language.name,
    isoCode2: language.isoCode2 ?? (language.code?.length === 2 ? language.code : undefined),
    isoCode3: language.isoCode3 ?? (language.code?.length === 3 ? language.code : undefined),
  };
}
